import { NavLink, useLocation } from 'react-router-dom'
import ensightLogo from '../assets/ensight-logo.png'
import { useAuth } from '../components/AuthProvider.jsx'
import { canManageParts, canManageProjects, canManageUsers } from '../utils/permissions'

const MENU = [
  { to: '/', label: '대시보드', end: true },
  { to: '/inventory', label: '재고관리', end: true },
  { to: '/inventory/review', label: '재고 검수', end: true, visible: canManageParts },
  { to: '/inventory/new', label: '신규부품 등록', end: true, visible: canManageParts },
  { to: '/transactions', label: '입출고 이력', end: true },
  { to: '/requests', label: '필요 품목 요청', end: true },
  { to: '/settings/users', label: '사용자 관리', end: true, visible: canManageUsers },
  { to: '/settings/projects', label: '프로젝트 관리', end: true, visible: canManageProjects },
  { to: '/settings', label: '설정', end: true },
]

export default function Sidebar({ open, onNavigate }) {
  const location = useLocation()
  const { user } = useAuth()
  const items = MENU.filter((item) => !item.visible || item.visible(user))

  return (
    <aside className={`sidebar ${open ? 'is-open' : ''}`}>
      <div className="sidebar__brand">
        <img className="sidebar__mark" src={ensightLogo} alt="" />
        <div>
          <strong>ENSIGHT</strong>
          <span>재고관리</span>
        </div>
      </div>
      <nav className="sidebar__nav" aria-label="주 메뉴">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => {
              const isReview = location.pathname.startsWith('/inventory/review')
              const isUsers = location.pathname.startsWith('/settings/users')
              const isProjects = location.pathname.startsWith('/settings/projects')
              const inventoryActive =
                item.to === '/inventory' &&
                location.pathname.startsWith('/inventory/') &&
                location.pathname !== '/inventory/new' &&
                !isReview
              const settingsActive = item.to === '/settings' && location.pathname === '/settings'
              const usersActive = item.to === '/settings/users' && isUsers
              const projectsActive = item.to === '/settings/projects' && isProjects
              return `sidebar__link${isActive || inventoryActive || settingsActive || usersActive || projectsActive ? ' is-active' : ''}`
            }}
            onClick={onNavigate}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  )
}
